import { HttpHandler } from 'msw'

import { openDoor } from './openDoor'

export const door: HttpHandler[] = [openDoor]
